/** Hierarquia completa de roles (ordem decrescente de autoridade — espelho do backend). */
export const ROLE_HIERARCHY = [
  'Socio',
  'Gestor',
  'Gerente',
  'Administrativo',
  'Secretaria',
  'ProfissionalSaude',
  'Marketing',
  'Recepcionista',
];

/** Roles criáveis via formulário (Socio é criado em fluxo separado). */
export const USER_ROLES = [
  'Gestor',
  'Gerente',
  'Administrativo',
  'Secretaria',
  'ProfissionalSaude',
  'Marketing',
  'Recepcionista',
];

/** Descrições exibidas no front (mesma ordem que USER_ROLES). */
export const USER_ROLE_LABELS = [
  'Gestor',
  'Gerente',
  'Administrativo',
  'Secretária',
  'Profissional de Saúde',
  'Marketing',
  'Recepcionista',
];

/** Opções para Select: { value, label } na ordem definida. */
export const USER_ROLE_OPTIONS = USER_ROLES.map((value, i) => ({
  value,
  label: USER_ROLE_LABELS[i],
}));

/** Retorna o label do role (fallback: valor). */
export const getRoleLabel = (role) => {
  const i = USER_ROLES.indexOf(role);
  return i >= 0 ? USER_ROLE_LABELS[i] : role || '';
};

/**
 * Retorna as opções de role visíveis para quem tem a role informada.
 * Segue a mesma hierarquia do backend: cada role vê apenas as posições abaixo da sua.
 * Socio nunca aparece como opção criável.
 */
export const getRoleOptionsVisiveisPor = (role) => {
  const idx = ROLE_HIERARCHY.indexOf(role);
  if (idx === -1) return [];
  const rolesVisiveis = ROLE_HIERARCHY.slice(idx + 1);
  return USER_ROLE_OPTIONS.filter((opt) => rolesVisiveis.includes(opt.value));
};
